import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import useUniqueId from 'hooks/useUniqueId';
import Card from 'components/Card';
import Modal from 'components/Modal';
import Button from 'components/Button';
import InlineList from 'components/InlineList';
import Panel from 'components/Panel';
import ModalHeadline from 'components/ModalHeadline';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function SimpleModal(_ref) {
  var buttons = _ref.buttons,
    children = _ref.children,
    id = _ref.id,
    onClose = _ref.onClose,
    title = _ref.title,
    subtitle = _ref.subtitle,
    body = _ref.body,
    width = _ref.width;
  var titleId = useUniqueId(id);
  return /*#__PURE__*/_jsx(Modal, {
    id: "".concat(titleId, "-modal"),
    "aria-labelledby": titleId,
    onRequestClose: onClose,
    width: width,
    children: /*#__PURE__*/_jsxs(Card, {
      variant: "raised",
      children: [/*#__PURE__*/_jsx(ModalHeadline, {
        title: title,
        titleId: titleId,
        onClose: onClose,
        subtitle: subtitle
      }), /*#__PURE__*/_jsx(Panel, {
        children: body
      }), /*#__PURE__*/_jsx(Panel, {
        align: "center",
        children: children ? children : /*#__PURE__*/_jsx(InlineList, {
          spacing: "xs",
          children: buttons === null || buttons === void 0 ? void 0 : buttons.map(function (button) {
            return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, button), {}, {
              children: button.label
            }), button.label);
          })
        })
      })]
    })
  });
}
export default SimpleModal;